import React, { useEffect, useState } from "react";
import {Table as AntTable,Button,Col,message,Pagination,Popconfirm,Row,notification,Form,Modal,Switch,Input,Tag,} from "antd";
import { useLocation } from "react-router-dom";
import Table, { ColumnsType } from "antd/es/table";
import {CheckOutlined,CloseOutlined,SearchOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import { components, getRowClassName } from "../../utils/utils";
import IMAGES from "../../const/Image";
import Search from "antd/es/input/Search";
import { SalonFilter } from "./SalonFilter";
import { FaSliders } from "react-icons/fa6";
import { Space, Tooltip } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SalonRequest from "./SalonRequest";
import { Tabs } from "antd";
import { isSuperAdmin } from "../../utils/utils";
// import { resolve } from "path";

const onChange = (key) => {
  console.log(key);
};

// const confirm = (e) => {
//   console.log(e);
//   message.success('Deleted!');
// };

const { confirm } = Modal;

const Salons = () => {

    const hasListPermission = usePermission("Salons", "List");
    // console.log('Has list permission:', hasListPermission);
    const hasAddPermission = usePermission("Salons", "Add");



  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.state?.tabKey || "1");
  const [activeTabUpdate, setActiveTabupdate] = useState(5);
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [updatedSalons, setUpdatedSalons] = useState([]);
  const initialFilter = {
    page: 1,
  };
  const [filter, setFilter] = useState(initialFilter);
  const [filteredSalons, setFilteredSalons] = useState([]);
  const [imgUpdateList, setImgUpdateList] = useState([]);
  const [updtedRecords, setTotalUpdatedRecords] = useState(0);
  const [updtedImgRecords, setTotalUpdatedimgRecords] = useState(0);

  const [form] = Form.useForm();


  const  getColumnsWithAadhar = (columns , navigate) =>{
    const columnsCopy = [...columns(navigate)]
    const ownerNameIndex = columnsCopy.findIndex((column) => column.key === 'ownerName');

    if (isSuperAdmin()) {
    columnsCopy.splice(ownerNameIndex + 1, 0, {
      title: "Aadhar Number",
      dataIndex: "aadhaarNumber",
      key: "aadhaarNumber",
      width: "200px",
    });
  }
  
  return columnsCopy;

  }


  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Salon ID",
      dataIndex: "salonId",
      key: "salonId",
      width: "200px",
    },
    {
      title: "Salon Name",
      dataIndex: "salonName",
      key: "salonName",
      width: "200px",
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      key: "ownerName",
      width: "200px",
    },

 
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "200px",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      width: "200px",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",

      render: (status, item) => (
        <>
          <Switch
            checked={status === 1}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            onChange={(checked) => handleStatusChange(checked, item)}
          />
        </>
      ),
    },
    {
      title: "Salon Type",
      dataIndex: "salonType",
      key: "salonType",
      width: "160px",
      render: (value) => {
        if (value === 0) return "Men";
        if (value === 1) return "Women";
        if (value === 2) return "Unisex";
      },
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      key: "serviceType",
      width: "160px",
      render: (value) => {
        if (value === 0) return "Home ";
        if (value === 1) return "Salon ";
        if (value === 2) return "Both";
      },
    },
    {
      title: "Service KM",
      dataIndex: "serviceKm",
      key: "serviceKm",
      width: "160px",
    },
    // {
    //   title: "Status",
    //   dataIndex: "Status",
    //   key: "Status",
    //   width:'160px'
    // },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      width: "200px",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/salons/details/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
          {/* <Tooltip title="Edit Details">
            <span className="action-icon-bg" onClick={()=>navigate("/salons/edit")}>
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip> */}
          {/* <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this task?"
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"    
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt=""/>
            </span>
          </Popconfirm> */}
        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const columns2 = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Salon ID",
      dataIndex: "salonId",
      key: "salonId",
      width: "200px",
    },
    {
      title: "Salon Name",
      dataIndex: "salonName",
      key: "salonName",
      width: "200px",
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      key: "ownerName",
      width: "200px",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "200px",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      width: "200px",
    },

    {
      title: "Approval",
      width: "150px",
      render: (text, record) => (
        <Space>
          {console.log(record?.salonId, "salon id")}
          <Tooltip
            title={
              record?.status === "Rejected" || record?.status === "Approved"
                ? null
                : "Reject"
            }
          >
            <Button
              onClick={() => handleApproved(record?.salonId, 3)}
              type="primary"
              danger
              shape="circle"
              disabled={
                record?.status === "Rejected" || record?.status === "Approved"
              }
              icon={<CloseOutlined />}
            />
          </Tooltip>
          <Tooltip
            title={
              "Created" === "Created"
                ? "Verify"
                : record?.status === "Verified"
                ? "Approve"
                : null
            }
          >
            <Button
              onClick={() => handleApproved(record?.salonId, 2)}
              type="primary"
              shape="circle"
              className={record?.status === "Verified" ? "success_button" : ""}
              disabled={
                record?.status === "Rejected" || record?.status === "Approved"
              }
              icon={<CheckOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",

      render: (status, item) => (
        <>
          <Switch
            checked={status === 1}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            onChange={(checked) => handleStatusChange(checked, item)}
          />
        </>
      ),
    },
    {
      title: "Salon Type",
      dataIndex: "salonType",
      key: "salonType",
      width: "160px",
      render: (value) => {
        if (value === 0) return "Men";
        if (value === 1) return "Women";
        if (value === 2) return "Unisex";
      },
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      key: "serviceType",
      width: "160px",
      render: (value) => {
        if (value === 0) return "Home ";
        if (value === 1) return "Salon ";
        if (value === 2) return "Both";
      },
    },
    {
      title: "Service KM",
      dataIndex: "serviceKm",
      key: "serviceKm",
      width: "160px",
    },
    // {
    //   title: "Status",
    //   dataIndex: "Status",
    //   key: "Status",
    //   width:'160px'
    // },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      width: "200px",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/salons/details/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
          {/* <Tooltip title="Edit Details">
            <span className="action-icon-bg" onClick={()=>navigate("/salons/edit")}>
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip> */}
          {/* <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this task?"
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"    
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt=""/>
            </span>
          </Popconfirm> */}
        </Space>
      ),
    },

    // Add other columns as needed
  ];

  const columns3 = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Salon ID",
      dataIndex: "salonId",
      key: "salonId",
      width: "200px",
    },
    {
      title: "Salon Name",
      dataIndex: "salonName",
      key: "salonName",
      width: "200px",
    },
    {
      title: "Owner Name",
      dataIndex: "ownerName",
      key: "ownerName",
      width: "200px",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "200px",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      width: "200px",
    },
    {
      title: "Rejection Reason",
      dataIndex: "rejectionReason",
      key: "rejectionReason",
      // width: "200px",
    },
    // {
    //   title: "Approval Status",
    //   render: (text, record) => (
    //     <Space>
    //       {console.log(record?.isAccountVerified, "salon id")}
    //       {record?.isAccountVerified === 0 && (
    //         <Tag color="#cd201f">Rejected</Tag>
    //       )}
    //     </Space>
    //   ),
    // },
    // {
    //   title: "Approval",
    //   render: (text, record) => (
    //     <>
    //       {record?.isAccountVerified === 0 && (
    //         <Space>
    //           {console.log(record?.salonId, "salon id")}
    //           <Tooltip
    //             title={
    //               record?.status === "Rejected" || record?.status === "Approved"
    //                 ? null
    //                 : "Reject"
    //             }
    //           >
    //             <Button
    //               onClick={() => handleApproved(record?.salonId, 2)}
    //               type="primary"
    //               danger
    //               shape="circle"
    //               disabled={
    //                 record?.status === "Rejected" ||
    //                 record?.status === "Approved"
    //               }
    //               icon={<CloseOutlined />}
    //             />
    //           </Tooltip>
    //           <Tooltip
    //             title={
    //               "Created" === "Created"
    //                 ? "Verify"
    //                 : record?.status === "Verified"
    //                 ? "Approve"
    //                 : null
    //             }
    //           >
    //             <Button
    //               onClick={() => handleApproved(record?.salonId, 1)}
    //               type="primary"
    //               shape="circle"
    //               className={
    //                 record?.status === "Verified" ? "success_button" : ""
    //               }
    //               disabled={
    //                 record?.status === "Rejected" ||
    //                 record?.status === "Approved"
    //               }
    //               icon={<CheckOutlined />}
    //             />
    //           </Tooltip>
    //         </Space>
    //       )}
    //     </>
    //   ),
    // },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",

      render: (status, item) => (
        <>
          <Switch
            checked={status === 1}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            onChange={(checked) => handleStatusChange(checked, item)}
          />
        </>
      ),
    },
    {
      title: "Salon Type",
      dataIndex: "salonType",
      key: "salonType",
      width: "160px",
      render: (value) => {
        if (value === 0) return "Men";
        if (value === 1) return "Women";
        if (value === 2) return "Unisex";
      },
    },
    {
      title: "Service Type",
      dataIndex: "serviceType",
      key: "serviceType",
      width: "160px",
      render: (value) => {
        if (value === 0) return "Home ";
        if (value === 1) return "Salon ";
        if (value === 2) return "Both";
      },
    },
    {
      title: "Service KM",
      dataIndex: "serviceKm",
      key: "serviceKm",
      width: "160px",
    },
    // {
    //   title: "Status",
    //   dataIndex: "Status",
    //   key: "Status",
    //   width:'160px'
    // },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      width: "200px",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/salons/details/${record.salonId}`)}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip>
        </Space>
      ),
    },

    // Add other columns as needed
  ];





  const updatedSalonColumns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },

    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   // width: 120,
    //   render: (text, record) => {
    //     const hasImage = record.updateRequest?.updatedImages[0]?.imageUrl;
    //     return (
    //       <img
    //         src={text || hasImage}
    //         alt="updated Image"
    //         style={{ width: "100%", height: "66px" }}
    //       />
    //     );
    //   },
    // },
    {
      title: "Previous Data",
      dataIndex: "previous ",
      key: "previous",
      width: 450,
      render: (text, record) => (
        <>
          <div>
            <strong> Salon Name:</strong> {record?.salonName || "N/A"}
          </div>
          <div>
            <strong>Address:</strong> {record?.salonAddress || "N/A"}
          </div>
        </>
      ),
    },
    // {
    //   title: "Requested Data",
    //   dataIndex: "requested",
    //   key: "requested",
    //   width : 450,
    //   render: (text , record) => (
    //     <>
    //       <div><strong>Requested Salon Name:</strong> {record.updateRequest?.salonName  || 'N/A'}</div>
    //       <div><strong> Requested Address:</strong> {record.updateRequest?.salonAddress?.address || 'N/A'}</div>
    //     </>
    //   ),
    // },

    {
      title: "Requested Data",
      dataIndex: "requested",
      key: "requested",
      width: 450,
      render: (text, record) => {
        const hasName =
          record.updateRequest?.salonName &&
          record.updateRequest?.salonName !== "N/A";
        const hasAddress =
          record.updateRequest?.salonAddress?.address &&
          record.updateRequest?.salonAddress?.address !== "N/A";

        if (!hasName && !hasAddress) {
          return "No requested data";
        }

        return (
          <>
            {hasName && (
              <div>
                <strong>Requested Salon Name:</strong>{" "}
                {record.updateRequest.salonName}
              </div>
            )}
            {hasAddress && (
              <div>
                <strong>Requested Address:</strong>{" "}
                {record.updateRequest.salonAddress.address} ,{" "}
                {record.updateRequest.salonAddress.nearBy},
                {record.updateRequest.salonAddress.area} ,
                {record.updateRequest.salonAddress.city} ,{" "}
                {record.updateRequest.salonAddress.state},{" "}
                {record.updateRequest.salonAddress.country},{" "}
                {record.updateRequest.salonAddress.pincode},
                {record.updateRequest.salonAddress.latitude},{" "}
                {record.updateRequest.salonAddress.longitude}
              </div>
            )}
          </>
        );
      },
    },

    // {
    //   title: 'Approval Status',
    //   render: (text, record) => (
    //     <Space>
    //       {console.log(record?.isAccountVerified, 'salon id')}
    //       {
    //         record?.isAccountVerified === 0 && <Tag color="#cd201f">Rejected</Tag>
    //       }

    //     </Space>
    //   )
    // },

    // {
    //   title: 'Approval Request',
    //   width : 250,
    //   render: (text, record) => (
    //     <>
    //     {
    //       record?.isApproved === 2 &&     <Space>
    //       {console.log(record?.salonId, 'salon id')}
    //       <Tooltip title={(record?.status === "Rejected" || record?.status === "Approved") ? null : "Reject"}>
    //         <Button onClick={() => handleSalonUpdateApproval( record?.salonId, 2)}
    //         type="primary"
    //         danger
    //         shape="circle"
    //         disabled={(record?.status === "Rejected" || record?.status === "Approved")}
    //         icon={<CloseOutlined />} />
    //         </Tooltip>

    //       <Tooltip title={'Created' === "Created" ? "Verify" : record?.status === "Verified" ? "Approve" : null}>
    //       <Button onClick={() => handleSalonUpdateApproval( record?.salonId, 1)}
    //       type="primary"
    //       shape="circle"
    //       className={record?.status === "Verified" ? "success_button" : ""}
    //       disabled={(record?.status === "Rejected" || record?.status === "Approved")}
    //       icon={<CheckOutlined />} />
    //       </Tooltip>
    //     </Space>
    //     }
    //     </>

    //   )
    // },

    {
      title: "Approval Request",
      width: 250,
      render: (text, record) => (
        <Space>
          <Tooltip title="Reject">
            <Button
              onClick={() => handleSalonUpdateApproval(record.salonId, 2)} // 2 for Reject
              type="primary"
              danger
              shape="circle"
              icon={<CloseOutlined />}
            />
          </Tooltip>
          <Tooltip title="Approve">
            <Button
              onClick={() => handleSalonUpdateApproval(record.salonId, 1)} // 1 for Approve
              type="primary"
              shape="circle"
              className="success_button"
              icon={<CheckOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  const updatedImgRequest = (navigate) => [
    {
      title: "S No.",
      dataIndex: "id",
      key: "id",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Salon Name",
      dataIndex: "salonSalonName",
      key: "salonSalonName",
    },

    {
      title: "Image",
      dataIndex: "salonImage",
      key: "salonImage",
      width: 400,
      render: (text) => (
        <img
          src={text || IMAGES.PlaceholderImage}
          alt="Category"
          style={{ width: "100%", height: "100px" }}
        />
      ),
    },
    // {
    //   title: "Previous Data",
    //   dataIndex: "previous ",
    //   key: "previous",
    //   width: 450,
    //   render: (text, record) => (
    //     <>
    //       <div>
    //         <strong> Salon Name:</strong> {record?.salonName || "N/A"}
    //       </div>
    //       <div>
    //         <strong>Address:</strong> {record?.salonAddress || "N/A"}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   title: "Requested Data",
    //   dataIndex: "requested",
    //   key: "requested",
    //   width : 450,
    //   render: (text , record) => (
    //     <>
    //       <div><strong>Requested Salon Name:</strong> {record.updateRequest?.salonName  || 'N/A'}</div>
    //       <div><strong> Requested Address:</strong> {record.updateRequest?.salonAddress?.address || 'N/A'}</div>
    //     </>
    //   ),
    // },

    // {
    //   title: "Requested Data",
    //   dataIndex: "requested",
    //   key: "requested",
    //   width: 450,
    //   render: (text, record) => {
    //     const hasName =
    //       record.updateRequest?.salonName &&
    //       record.updateRequest?.salonName !== "N/A";
    //     const hasAddress =
    //       record.updateRequest?.salonAddress?.address &&
    //       record.updateRequest?.salonAddress?.address !== "N/A";

    //     if (!hasName && !hasAddress) {
    //       return "No requested data";
    //     }

    //     return (
    //       <>
    //         {hasName && (
    //           <div>
    //             <strong>Requested Salon Name:</strong>{" "}
    //             {record.updateRequest.salonName}
    //           </div>
    //         )}
    //         {hasAddress && (
    //           <div>
    //             <strong>Requested Address:</strong>{" "}
    //             {record.updateRequest.salonAddress.address} ,{" "}
    //             {record.updateRequest.salonAddress.nearBy},
    //             {record.updateRequest.salonAddress.area} ,
    //             {record.updateRequest.salonAddress.city} ,{" "}
    //             {record.updateRequest.salonAddress.state},{" "}
    //             {record.updateRequest.salonAddress.country},{" "}
    //             {record.updateRequest.salonAddress.pincode},
    //             {record.updateRequest.salonAddress.latitude},{" "}
    //             {record.updateRequest.salonAddress.longitude}
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },

    // {
    //   title: 'Approval Status',
    //   render: (text, record) => (
    //     <Space>
    //       {console.log(record?.isAccountVerified, 'salon id')}
    //       {
    //         record?.isAccountVerified === 0 && <Tag color="#cd201f">Rejected</Tag>
    //       }

    //     </Space>
    //   )
    // },

    // {
    //   title: 'Approval Request',
    //   width : 250,
    //   render: (text, record) => (
    //     <>
    //     {
    //       record?.isApproved === 2 &&     <Space>
    //       {console.log(record?.salonId, 'salon id')}
    //       <Tooltip title={(record?.status === "Rejected" || record?.status === "Approved") ? null : "Reject"}>
    //         <Button onClick={() => handleSalonUpdateApproval( record?.salonId, 2)}
    //         type="primary"
    //         danger
    //         shape="circle"
    //         disabled={(record?.status === "Rejected" || record?.status === "Approved")}
    //         icon={<CloseOutlined />} />
    //         </Tooltip>

    //       <Tooltip title={'Created' === "Created" ? "Verify" : record?.status === "Verified" ? "Approve" : null}>
    //       <Button onClick={() => handleSalonUpdateApproval( record?.salonId, 1)}
    //       type="primary"
    //       shape="circle"
    //       className={record?.status === "Verified" ? "success_button" : ""}
    //       disabled={(record?.status === "Rejected" || record?.status === "Approved")}
    //       icon={<CheckOutlined />} />
    //       </Tooltip>
    //     </Space>
    //     }
    //     </>

    //   )
    // },

    {
      title: "Approval Request",
      render: (text, record) => (
        <Space>
          <Tooltip title="Reject">
            <Button
              onClick={() =>
                handleImageUpdateApproval(
                  record.salonId,
                  record.id,
                  "rejected"
                )
              }
              type="primary"
              danger
              shape="circle"
              icon={<CloseOutlined />}
            />
          </Tooltip>
          <Tooltip title="Approve">
            <Button
              onClick={() =>
                handleImageUpdateApproval(
                  record.salonId,
                   record.id,
                  "approved"
                )
              }
              type="primary"
              shape="circle"
              className="success_button"
              icon={<CheckOutlined />}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  const handleChangeupdate = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current, // Update current page from pagination event
    }));
  };
  const handleChange = (pagination) => {
    setFilter((prev) => ({
      ...prev,
      page: pagination.current,
    }));
  };
  const items = [
    {
      key: "1",
      label: "All Salons",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
           columns={getColumnsWithAadhar(columns, navigate)}
            loading={loading}
            // dataSource={labList || null}
            scroll={{ x: "max-content" }}
            onChange={handleChange}
            dataSource={filteredSalons || null}
            // pagination={{
            //   total: totalRecords,
            //   current: filter?.page || 0,
            //   defaultCurrent: 1
            // }}

            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: "New Requests",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
                columns={getColumnsWithAadhar(columns2, navigate)}
            loading={loading}
            // dataSource={labList.filter((item) => item.status === 0)}
            scroll={{ x: "max-content" }}
            onChange={handleChange}
            dataSource={filteredSalons || null}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
          />
        </div>
      ),
    },
    {
      key: "3",
      label: "Active",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
           columns={getColumnsWithAadhar(columns, navigate)}
            loading={loading}
            // dataSource={labList.filter((item) => item.status === 1)}
            scroll={{ x: "max-content" }}
            onChange={handleChange}
            dataSource={filteredSalons || null}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
          />
        </div>
      ),
    },
    {
      key: "4",
      label: "Inactive",
      children: (
        <div style={{}}>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
          columns={getColumnsWithAadhar(columns3, navigate)}
            loading={loading}
            // dataSource={labList.filter((item) => item.status === 0)}
            scroll={{ x: "max-content" }}
            onChange={handleChange}
            dataSource={filteredSalons || null}
            pagination={{
              total: totalRecords, // Total items from API
              current: filter?.page, // Current page from API
              pageSize: 10, // Keep it fixed to 10 as per API request
              showSizeChanger: false, // Disable changing page size
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
          />
        </div>
      ),
    },
  
    {
      key: "5",
      label: "Update Request",
      children: (
        <div>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={updatedSalonColumns(navigate)}
            loading={loading}
            // dataSource={labList.filter((item) => item.status === 0)}
            scroll={{ x: "max-content" }}
            onChange={handleChangeupdate}
            dataSource={updatedSalons || null}
            pagination={{
              total: updtedRecords,
              current: filter?.page,
              pageSize: 10,
              showSizeChanger: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
          />
        </div>
      ),
    },
    {
      key: "6",
      label: "Update Image Request",
      children: (
        <div>
          <Table
            size="middle"
            bordered
            rowClassName={getRowClassName}
            components={components}
            columns={updatedImgRequest(navigate)}
            loading={loading}
            // dataSource={labList.filter((item) => item.status === 0)}
            scroll={{ x: "max-content" }}
            onChange={handleChangeupdate}
            dataSource={imgUpdateList || null}
            pagination={{
              total: updtedImgRecords,
              current: filter?.page,
              pageSize: 10,
              showSizeChanger: false,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page) => setFilter((prev) => ({ ...prev, page })), // Ensure correct page change
            }}
          />
        </div>
      ),
    },
  ];

  const fetchSalonList = () => {
    setLoading(true);
    SalonRequest.salonList({ ...filter, type: activeTab })
      .then((response) => {
        const rawData = response?.data?.data?.list || [];
        console.log(rawData);
        const totalCount = response?.data?.data?.totalCount || 0;

        setFilteredSalons(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        // message.error("Failed to fetch salon list")
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (activeTab === "6") {
      fetchUpdatedImageList();
    } else {
      fetchSalonList();
    }
  }, [filter, activeTab]);

  const fetchUpdatedImageList = () => {
    setLoading(true);
    SalonRequest.updateImgList({ ...filter, type: activeTab })
      .then((response) => {
        const rawData = response?.data?.data?.response || [];
        console.log(rawData);
        const totalCount = response?.data?.data?.pagination?.totalRecords || 0;

        setImgUpdateList(rawData);
        setTotalUpdatedimgRecords(totalCount);
      })
      .catch((error) => {
        // message.error("Failed to fetch salon list")
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUpdatedImageList();
  }, [filter, activeTab]);

  const fetchUpdatedSalonList = () => {
    setLoading(true);
    SalonRequest.updatedSalonsList({ ...filter, type: activeTabUpdate })
      .then((response) => {
        const rawData = response?.data?.data?.response || [];
        console.log(rawData);
        const totalCount = response?.data?.data?.pagination?.totalRecords || 0;
        setUpdatedSalons(rawData);
        // setFilteredSalons(rawData)
        setTotalUpdatedRecords(totalCount);
      })
      .catch((error) => {
        // message.error("Failed to fetch salon list")
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUpdatedSalonList();
  }, [filter, activeTabUpdate]);

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    console.log("filter", filter);
    setIsModalOpen(false);
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${
        checked ? "activate" : "deactivate"
      } this salon?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        SalonRequest.updateSalonStatus({
          status: checked ? 1 : 0,
          salonId: item.salonId,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.salonId === item.salonId
                    ? { ...el, status: checked ? "1" : "0" }
                    : el
                )
              );
              fetchSalonList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const handleApproved = (saloonId, item) => {
    let reason = "";
    const modal = confirm({
      title: `Are you sure you want to ${
        item === 2 ? "approve" : "reject"
      } this salon?`,
      content: item !== 2 && (
        <div style={{ marginTop: 16 }}>
          <Input.TextArea
            placeholder="Enter reason for the rejection"
            onChange={(e) => {
              reason = e.target.value;
              modal.update({
                okButtonProps: {
                  disabled: !reason.trim(),
                },
              });
            }}
          />
        </div>
      ),
      okText: "Yes",
      okType: "danger",
      okButtonProps: {
        disabled: item !== 2 ? true : false,
      },
      cancelText: "No",
      onOk() {
        setLoading(true);
        SalonRequest.approveSalon({
          salonId: saloonId,
          isAccountVerified: item,
          rejection_reason: item !== 2 ? reason : undefined,

          // 2 for approved, 3 for rejected
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: `Salon ${
                  item === 2 ? "approved" : "rejected"
                } successfully`,
              });
              fetchSalonList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const handleSalonUpdateApproval = (salonId, isApproved) => {
    let reason = "";
    const modal = confirm({
      title: `Are you sure you want to ${
        isApproved === 1 ? "approve" : "reject"
      } this salon update?`,

      content: isApproved !== 1 && (
        <div style={{ marginTop: 16 }}>
          <Input.TextArea
            placeholder="Enter reason for the rejection"
            onChange={(e) => {
              reason = e.target.value;
              modal.update({
                okButtonProps: {
                  disabled: !reason.trim(),
                },
              });
            }}
          />
        </div>
      ),
      okText: "Yes",
      okType: "danger",
      okButtonProps: {
        disabled: isApproved !== 1 ? true : false,
      },
      cancelText: "No",
      onOk() {
        setLoading(true);
        SalonRequest.approveUpdateSalon({
          salonId: salonId,
          isApproved: isApproved, // 1 for Approve, 2 for Reject
          rejection_reason: isApproved !== 1 ? reason : undefined,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: `Salon update ${
                  isApproved === 1 ? "approved" : "rejected"
                } successfully`,
              });
              fetchUpdatedSalonList(); // Refresh the list after approval/rejection
            } else {
              notification.error({
                message: "Failed to update salon status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update salon status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };
  const handleImageUpdateApproval = (salonId, imageId, status) => {
    let reason = "";
    console.log("imageId", imageId);
    
    const modal = confirm({
      title: `Are you sure you want to ${
        status === "approved" ? "approve" : "reject"
      } this Image update?`,

      content: status === "rejected" && ( // Only show for reject case
        <div style={{ marginTop: 16 }}>
          <Input.TextArea
            placeholder="Enter reason for the rejection"
            onChange={(e) => {
              reason = e.target.value;
              modal.update({
                okButtonProps: {
                  disabled: !reason.trim(),
                },
              });
            }}
          />
        </div>
      ),
      okText: "Yes",
      okType: "danger",
      okButtonProps: {
        disabled: status === "rejected" ? true : false, // Disabled only for reject until reason is provided
      },
      cancelText: "No",
      onOk() {
        setLoading(true);
        SalonRequest.approveUpdateImage({
          salonId: salonId,
          imageId: imageId,
          status: status,
          rejection_reason: status === "rejected" ? reason : undefined, // Only include for reject
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: `Image update ${
                  status === "approved" ? "approved" : "rejected"
                } successfully`,
              });
              // Call your refresh function here with proper parameters
             fetchUpdatedImageList();
            } else {
              notification.error({
                message: "Failed to update image status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update image status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    console.log("Show Modal");
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="">
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Salons List</h1>
          </Col>
          <Col style={{ gap: "1rem", display: "flex" }}>
            <Input
              placeholder="Search..."
              size="large"
              className="FilterSearchBox"
              onChange={(e) =>
                setFilterForm({ ...filterForm, search: e.target.value })
              }
              value={filterForm?.search}
              style={{ width: "100%" }}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleFilter();
                }
              }}
            />

            <Button
              onClick={handleFilter}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <SearchOutlined />
            </Button>
            <Button
              type="primary"
              className="addcity-btn"
              onClick={resetFilters}
              style={{ height: "39px" }}
            >
              Reset
            </Button>

            <Button
              onClick={() => showModal()}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <FaSliders />
            </Button>

                {hasAddPermission && (
            <Button
              onClick={() => navigate("/salons/create-user")}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
              style={{ height: "39px" }}
            >
              <img src={IMAGES.AddIconFilters} alt="" />
            </Button>
                )}

          </Col>
        </Row>
      </div>
      <Tabs
        defaultActiveKey={activeTab}
        items={items}
        onChange={(key) => {
          if (key != 5) {
            setActiveTab(key);
          } else {
            // setActiveTabupdate(key);
            fetchUpdatedSalonList();
          }
        }}
      />

      <SalonFilter
        handleFilter={handleFilter}
        form={form}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
      />
    </>
  );
};

export default Salons;
